import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Turbo は redirect 先の本文を受け取る前に submitter の disabled と文言を戻すので、成功した送信はページが置き換わるまで
// 送信中の文言のまま押せなくする。押せないボタンと書いた本文を snapshot に残さないよう、送信元のページは cache しない
export default class extends Controller {
  hold({ detail: { success, formSubmission: { submitter } } }) {
    if (!success) return

    submitter.disabled = true
    submitter.value = submitter.dataset.turboSubmitsWith
    Turbo.cache.exemptPageFromCache()
  }
}
